import alpha from "color-alpha";
const borderedStyles = ({
  theme,
  ownerState
}) => {
  if (ownerState.variant !== "bordered")
    return;
  return {
    ...ownerState.color === "aqua" && {
      border: `1px solid ${theme.palette.primary[800]}`,
      color: theme.palette.primary[800],
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.primary[25],
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: theme.palette.primary[50],
        boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px 1px 1px 2px rgba(0, 0, 0, 0.3), 0px 0px 2px 2px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: `1px solid ${alpha(theme.palette.grey[900], 0.12)}`,
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.12),
        color: alpha(theme.palette.grey[900], 0.12)
      }
    },
    ...ownerState.color === "purple" && {
      border: `1px solid ${theme.palette.highlight3[700]}`,
      color: theme.palette.highlight3[700],
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: alpha(theme.palette.highlight3[700], 0.08),
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: alpha(theme.palette.highlight3[700], 0.12),
        boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px 1px 1px 2px rgba(0, 0, 0, 0.3), 0px 0px 2px 2px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: `1px solid ${alpha(theme.palette.grey[900], 0.12)}`,
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.12),
        color: alpha(theme.palette.grey[900], 0.12)
      }
    },
    ...ownerState.color === "blue" && {
      border: `1px solid ${theme.palette.highlight2[700]}`,
      color: theme.palette.highlight2[700],
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: alpha(theme.palette.highlight2[700], 0.08),
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: alpha(theme.palette.highlight2[700], 0.12),
        boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px 1px 1px 2px rgba(0, 0, 0, 0.3), 0px 0px 2px 2px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: `1px solid ${alpha(theme.palette.grey[900], 0.12)}`,
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.12),
        color: alpha(theme.palette.grey[900], 0.12)
      }
    },
    ...ownerState.color === "orange" && {
      border: `1px solid ${theme.palette.secondary[800]}`,
      color: theme.palette.secondary[800],
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.secondary[25],
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: theme.palette.secondary[25],
        boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px 1px 1px 2px rgba(0, 0, 0, 0.3), 0px 0px 2px 2px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: `1px solid ${alpha(theme.palette.grey[900], 0.12)}`,
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.12),
        color: alpha(theme.palette.grey[900], 0.12)
      }
    },
    ...ownerState.color === "white" && {
      border: `1px solid ${theme.palette.common.white}`,
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.08),
        boxShadow: "0px -0.5px 0.5px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35);"
      },
      "&:focus-visible": {
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.12),
        boxShadow: `0px -0.5px 0.5px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: `1px solid ${alpha(theme.palette.common.white ?? "#fff", 0.12)}`,
        backgroundColor: "transparent",
        color: alpha(theme.palette.common.white ?? "#fff", 0.38)
      }
    },
    ...ownerState.color === "grey" && {
      border: `1px solid ${theme.palette.grey[800]}`,
      color: theme.palette.grey[800],
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: "#F0F0F0",
        boxShadow: "0px -0.5px 0.5px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35);"
      },
      "&:focus-visible": {
        backgroundColor: "#E8E8E8",
        boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px -0.5px 0.5px 2px rgba(0, 0, 0, 0.1), 0px 0.5px 1px 2px rgba(0, 0, 0, 0.35);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        border: `1px solid ${alpha(theme.palette.grey[800], 0.12)}`,
        backgroundColor: alpha(theme.palette.common.white ?? "#fff", 0.12),
        color: alpha(theme.palette.grey[800], 0.38)
      }
    }
  };
};
export {
  borderedStyles
};
